
import { Component, Mixins, Watch } from 'vue-property-decorator';
import HistoryCard from '@/features/shipment-history/components/index.vue';
import DetailsAside from '@/features/shipment-history/components/details/DetailsAside.vue';
import SchedulePickupFlow from '@/features/schedule-pickup/components/SchedulePickupFlow.vue';
import { SchedulePickupMixin } from '@/features/schedule-pickup/components/mixins';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { hideFloatingWidgets, showFloatingWidgets } from '@/features/feedback-tool/helpers';

type detailsTab = 'details' | 'tracking' | 'comments'

@Component({
  components: {
    HistoryCard,
    DetailsAside,
    SchedulePickupFlow,
  },
})
export default class HistoryResults extends Mixins(SchedulePickupMixin) {
  private showDetails = false;

  private detailsInitTab: detailsTab = 'details';

  private carrierTrackingNumberForDetails = '';

  private trackingNumberForDetails = '';

  private hideFloatingWidgets = hideFloatingWidgets;

  private showFloatingWidgets = showFloatingWidgets;

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  mounted(): void {
    eventBus.$on(eventNames.OPEN_HISTORY_DETAILS, this.openDetails);
  }

  private openDetails(
    {
      tab,
      carrierTrackingNumber,
      trackingNumber,
    },
  ): void {
    if (tab) {
      this.detailsInitTab = tab;
    }

    if (this.showDetails && tab) {
      this.detailsInitTab = tab;
    }

    this.carrierTrackingNumberForDetails = carrierTrackingNumber;
    this.trackingNumberForDetails = trackingNumber;

    this.showDetails = true;
  }

  private closeDetails(): void {
    this.showDetails = false;
    eventBus.$emit(eventNames.CLOSE_HISTORY_DETAILS);
  }

  @Watch('showDetails')
  private hideShowFloatingWidgets() {
    if (this.showDetails) {
      this.hideFloatingWidgets();
      return;
    }
    this.showFloatingWidgets();
  }
}
